import MicroModal from 'micromodal';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-img-modal' })
export class ImgModalComponent {
	private modalContentSelector = ".js-img-modal-content";
	private content;

	constructor(private element: HTMLElement) {
		element.addEventListener('click', () => {
			if (window.innerWidth > 900) {
				MicroModal.show(element.getAttribute('data-trigger-for'), {
					onShow: this.openModal.bind(this),
				});
			}
		})
	}

	openModal(modal: Element) {
		this.content = modal.querySelector(this.modalContentSelector) as HTMLElement;
		if (this.content) {
			const img = this.element.querySelector('picture').cloneNode(true);
			this.content.appendChild(img);
		}

		const closeTriggers = Array.from(modal.getElementsByClassName('js-modal-close'));
		closeTriggers.forEach(trigger => trigger.addEventListener('click', this.closeModal.bind(this)));
	}

	closeModal() {
		if (this.content) {
			this.content.innerHTML = '';
		}

		const modalId = this.element.getAttribute('data-trigger-for');
		MicroModal.close(modalId);
	}
}
